export default {
  general: {
    errors: {
      usernameNotFoundInDatabase: "Username is not found in the base",
      usernameOrPasswordNotFound: "Username or password is not found",
      accessDenied: "Access denied",
      invalidUsernameOrPassword: "Invalid username or password",
      accountExpired: "Account expired",
      sessionExpired: "Session expired",
      notModified: "Database is not modified"
    },
    errorMessages: {
      details: 'details',
      error: 'Error',
      login: {
        noUsername: "User name needed",
        noPassword: "Password needed",
        noLanguage: "Language needed",
        noConnection: "Connection needed"
      }
    }
  }
};
